import ImportButton from "components/buttons/ImportButton";
import React, { useState } from "react";
import { useTranslate } from "react-admin";

import { ImportUploadDialog } from "./ImportUploadDialog";

export const ImportDialogButton = ({
	label,
	dialogTitle,
	uploadEndpoint,
	successMessage,
	onSuccess,
	initialValues = {},
	acceptTypes = ".xls,.xlsx",
	renderCustomForm = null,
	exportMode = false,
	exportButtonLabel = "osfc.buttons.export-product",
	exportFileName = "export.xlsx",
}) => {
	const translate = useTranslate();
	const [dialogOpen, setDialogOpen] = useState(false);

	const handleOnDialogOpen = () => {
		setDialogOpen(true);
	};

	const handleOnDialogClose = () => {
		setDialogOpen(false);
	};

	const handleOnUploadSuccess = () => {
		if (onSuccess) {
			onSuccess();
		}
		handleOnDialogClose();
	};

	return (
		<React.Fragment>
			<ImportButton onClick={handleOnDialogOpen} label={translate(label)} />
			{dialogOpen && (
				<ImportUploadDialog
					title={dialogTitle}
					uploadEndpoint={uploadEndpoint}
					successMessage={successMessage}
					onDialogClose={handleOnDialogClose}
					onUploadSuccess={handleOnUploadSuccess}
					initialValues={initialValues}
					acceptTypes={acceptTypes}
					renderCustomForm={renderCustomForm}
					exportMode={exportMode}
					exportButtonLabel={exportButtonLabel}
					exportFileName={exportFileName}
				/>
			)}
		</React.Fragment>
	);
};
